import * as firebase from 'firebase';

const config = {
	apiKey: "AIzaSyAlqKl5p4ZgUq89wmkD_NxT331E01Aa6Vo",
	authDomain: "dreamteamapp-b336f.firebaseapp.com",
	databaseURL: "https://dreamteamapp-b336f.firebaseio.com",
	projectId: "dreamteamapp-b336f",
	storageBucket: "dreamteamapp-b336f.appspot.com",
	messagingSenderId: "500762178851",
	appId: "1:500762178851:web:7ee1302d7cbc90fb6d8896"
};

firebase.initializeApp(config);

export default firebase;